import ServiceDetailPage from "./utilities/servicedetailpage";
import { servicePageContent } from "./utilities/servicepagecontent";

export default function AIAgents() {
  return <ServiceDetailPage service={servicePageContent.aiAgents} />;
}
